<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <div class="ft2-form-group">
        <label>
            Label
        </label>
        <ng-container *ngFor="let model of value">
            <div class="ft2-input-container" [ngClass]="{'-pure': !model?.[bindLabel]}">
                <div class="d-flex f-nowrap v-center">
                    <input class="ft2-input -large"
                           #control="ngModel"
                           maxlength="50"
                           required
                           [ngClass]="{'-pure': model?.[bindLabel]}"
                           [(ngModel)]="model[bindLabel]">
                    <div class="ft2-input-legend v-center">
                        <span class="ft2-input-legend_count small-text mr-2">
                            {{ model[bindLabel]?.length || 0 }} / 50
                        </span>
                        <span class="ft2-input-legend_language"
                              *ngIf="model?.languageName && value?.length > 1">
                            {{ model.languageName }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="ft2-form-group">
        <label>
            Summary
        </label>
        <ng-container *ngFor="let model of value">
            <div class="ft2-input-container" [ngClass]="{'-pure': !model?.[bindSummary]}">
                <div class="d-flex f-nowrap v-center">
                    <input class="ft2-input -large"
                           #controlsModelRef="ngModel"
                           maxlength="100"
                           required
                           [ngClass]="{'-pure': model?.[bindSummary]}"
                           [(ngModel)]="model[bindSummary]">
                    <div class="ft2-input-legend v-center">
                        <span class="ft2-input-legend_count small-text mr-2">
                            {{ model[bindSummary]?.length || 0 }} / 100
                        </span>
                        <span class="ft2-input-legend_language"
                              *ngIf="model?.languageName && value?.length > 1">
                            {{ model.languageName }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="ft2-form-group">
        <label>
            Extra info (Optional)
        </label>
        <ng-container *ngFor="let model of value">
            <div class="ft2-input-container" [ngClass]="{'-pure': !model?.[bindDescription]}">
                <div class="d-flex f-nowrap v-center">
                       <textarea class="ft2-textarea"
                                 placeholder="Optional"
                                 #controlsModelRef="ngModel"
                                 maxlength="400"
                                 [ngClass]="{'-pure': model?.[bindDescription]}"
                                 [(ngModel)]="model[bindDescription]">
                             </textarea>
                    <div class="ft2-input-legend v-center">
                        <span class="ft2-input-legend_count small-text mr-2">
                            {{ model[bindDescription]?.length || 0 }} / 400
                        </span>
                         <span class="ft2-input-legend_language"
                               *ngIf="model?.languageName && value?.length > 1">
                            {{ model.languageName }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ft-modal-editor-wrapper>
